<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="managerComposer">
    <b-overlay
      :show="__isOnLoad"
      variant="white"
      rounded
      opacity="0.70"
      spinner-variant="primary"
      spinner-small
    >
      <div
        class="managerPanels"
        :class="{ 'managerPanels-avoir': __isAvoir }"
      >
        <div class="managerEditionPanel">
          <div class="managerPopup">
            <div class="managerPopup-top managerPopupHead">
              <div>
                <h3 class="managerPopup-title">{{ managerTitle }}</h3>
                <div class="managerPopup-subtitle">{{ managerSubtitle }}</div>
              </div>
              <div class="managerModeBadge">{{ managerModeBadge }}</div>
            </div>

            <div class="managerToolbar" v-if="__isAvoir || __isSingelton">
              <b-button
                size="sm"
                variant="success"
                class="managerToolbar-btn"
                :disabled="__isSaving"
                @click="__onSave()"
                v-if="__isAvoir || __isSingelton"
              >
                Enregistrer
              </b-button>
              <b-button
                size="sm"
                :variant="inPreview === 'TPL' ? 'dark' : 'outline-secondary'"
                class="managerToolbar-btn"
                @click="resetPreview()"
                v-if="__isSingelton"
              >
                Aperçu
              </b-button>
              <b-button
                size="sm"
                :variant="inPreview === 'PRODS' ? 'primary' : 'outline-primary'"
                class="managerToolbar-btn"
                @click="addProd()"
                v-if="__isSingelton"
              >
                + Produit
              </b-button>
              <b-button
                size="sm"
                :variant="inPreview === 'SERVICES' ? 'info' : 'outline-info'"
                class="managerToolbar-btn"
                @click="addServices()"
                v-if="__isSingelton"
              >
                + Service
              </b-button>
            </div>

            <div class="managerPopup-card" v-if="!__isAvoir">
              <div class="managerSectionEyebrow">Configuration</div>
              <div class="managerSectionTitle">Paramètres du document</div>
              <div class="row managerFieldsRow">
                <div
                  class="col-lg-4 col-md-6 managerField"
                  v-if="['ROOT', 'ADMIN'].includes(__admin.type)"
                >
                  <selector
                    _id="6784308adefa389903ad4ea4"
                    :_forceFirstIfNull="true"
                    :_parentItem="__item"
                    _warpper="archive"
                  ></selector>
                </div>
                <div class="col-lg-4 col-md-6 managerField">
                  <selector
                    _id="67845a592c5d1fe8fce5165f"
                    :_forceFirstIfNull="true"
                    :_parentItem="__item"
                    _warpper="tva"
                  ></selector>
                </div>
                <div
                  class="col-lg-4 col-md-6 managerField"
                  v-if="__isFacture === false && __item.type !== 'BON DE COMMANDE'"
                >
                  <selector
                    _id="678ecc1983d6400562ac7e96"
                    :_forceFirstIfNull="true"
                    :_parentItem="__item"
                    _warpper="type"
                  ></selector>
                </div>
                <div class="col-lg-4 col-md-6 managerField datePick" v-else>
                  <div class="managerFieldLabel">Date facture</div>
                  <b-form-datepicker
                    id="example-datepicker"
                    placeholder="Date facture"
                    selected-variant="primary"
                    today-variant="primary"
                    nav-button-variant="secondary"
                    variant="danger"
                    v-model="__item.createdAt"
                  ></b-form-datepicker>
                </div>
                <div
                  class="col-lg-4 col-md-6 managerField"
                  v-if="['ROOT', 'ADMIN'].includes(__admin.type)"
                >
                  <selector
                    :_customData="userListStructure"
                    :_parentItem="__item"
                    _warpper="assignedToID"
                    :_cb="onChangeAssigne"
                  ></selector>
                </div>
              </div>
            </div>

            <div class="managerPopup-card">
              <div class="managerSectionEyebrow">Contexte</div>
              <div class="managerSectionTitle">Notes internes</div>
              <div class="row managerFieldsRow">
                <div class="col-md-6 managerField">
                  <div class="managerFieldLabel">Remarque</div>
                  <base-input
                    placeholder="Remarque"
                    v-model="__item.moreinfo"
                    type="string"
                    :error="errorCtrl"
                  >
                  </base-input>
                </div>
                <div class="col-md-6 managerField">
                  <div class="managerFieldLabel">Informations supplémentaires</div>
                  <base-input
                    placeholder="Informations supplémentaires"
                    v-model="__item.moreDetail"
                    type="string"
                    :error="errorCtrl"
                  >
                  </base-input>
                </div>
              </div>
            </div>

            <div class="managerPopup-card" v-if="__item.owner && __item.owner.pid">
              <div class="managerSectionEyebrow">Client</div>
              <div class="managerSectionTitle">Récapitulatif client</div>
              <RecapSte :__ID="__item.owner.pid"></RecapSte>
            </div>

            <div class="managerPopup-card" v-if="infoProdID !== ''">
              <div class="managerSectionEyebrow">Article cible</div>
              <div class="managerSectionTitle">Détail du produit</div>
              <RecapProd :__ID="infoProdID"></RecapProd>
            </div>

            <div class="managerPopup-card managerLinesCard">
              <div class="managerSectionHead">
                <div>
                  <div class="managerSectionEyebrow">Contenu</div>
                  <div class="managerSectionTitle">Lignes du document</div>
                </div>
                <div class="managerSectionMeta">{{ lineCountLabel }}</div>
              </div>
              <Devis
                :__object="__item"
                :__infoProdID="infoProdID"
                v-on="{ showProdInfo: onShowProdInfo }"
              ></Devis>
            </div>
          </div>
        </div>

        <div class="managerPreviewPanel">
          <div class="managerPopup">
            <div class="managerPopup-top managerPopupHead">
              <div>
                <h3 class="managerPopup-title">{{ previewTitle }}</h3>
                <div class="managerPopup-subtitle">{{ previewSubtitle }}</div>
              </div>
              <div class="managerModeBadge managerModeBadge-light">{{ previewBadge }}</div>
            </div>

            <div class="managerPopup-card managerPreviewCard">
              <Template v-if="inPreview === 'TPL'" :__object="__item"></Template>
              <Prods
                v-if="inPreview === 'PRODS'"
                :isLightMode="true"
                :devisIDs="getDevisID"
                :onSelect="onSelectProd()"
              ></Prods>
              <Services
                v-if="inPreview === 'SERVICES'"
                :isLightMode="true"
                :devisIDs="getDevisID"
                :onSelect="onSelectProd()"
              ></Services>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import RecapSte from "@/pages/societes/Recap";
import RecapProd from "@/pages/prods/Recap";
import Prods from "@/pages/prods/index";
import Services from "@/pages/services/index";
import Devis from "./Devis";
import Template from "./Template";

export default {
  components: {
    RecapSte,
    RecapProd,
    Devis,
    Template,
    Prods,
    Services,
  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isSingelton: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isAvoir: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isFacture: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    
    __onSave: {
      type: Function,
      default: () => {
        return ()=>{};
      },
    },
    __isSaving: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    __admin: {
      type: Object,
      default: () => {
        return {};
      },
    },
    __userList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => {
    return {
      fullList: [],
      errorCtrl: [],
      userListStructure: {},
      infoProdID: "",
      inPreview: "TPL",
      onGoingReq: [],
      devisIds: [],
    };
  },
  methods: {
    onSelectProd() {
      return (arg) => {
        if (!Array.isArray(this.__item.devis)) {
          this.$set(this.__item, "devis", []);
        }
        this.__item.devis.push({
          id: arg._id,
          name: arg.name,
          ref: arg.ref,
          pic: arg.pic,
          qte: 1,
          isValide: false,
          type: (this.inPreview === 'PRODS') ? 'PRD' : 'SRV',
          prix: arg.prixV,
          remise: 0,
          total: 0,
        });
      };
    },

    resetPreview() {
      this.inPreview = "TPL";
    },

    addProd() {
      this.inPreview = "PRODS";
    },

    addServices() {
      this.inPreview = "SERVICES";
    },

    setUserList() {
      if (this.$props.__userList.length === 0) return;
      this.userListStructure = {};
      this.userListStructure.editable = true;
      this.userListStructure.grp = {
        type: "DD",
        name: "Commercial",
      };
      this.userListStructure.list = this.$props.__userList.map((c) => ({
        text: c.name,
        value: c.id,
      }));
    },

    getTof(c) {
      return c ? this.__.resolveMediaPath(c, "uploads/catalogue/No-Image.jpg") : "";
    },
    onShowProdInfo(id) {
      this.infoProdID = id;
    },

    getCommercial(id) {
      let $onNext = (response) => {
        console.log(this.$parent.$parent)
        this.$parent.$parent.setAssign(this.__item, response.data[0])
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: '/admins/'+id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    onChangeAssigne(ID) {
      this.getCommercial(ID[0].value)
    }
  },

  mounted() {
    this.setUserList();
  },

  computed: {
    managerTitle() {
      if (this.__isAvoir) {
        return "Composer l'avoir";
      }
      if (this.__item.type === "BON DE COMMANDE") {
        return "Composer la commande";
      }
      return this.__isFacture ? "Composer la facture" : "Composer le devis";
    },
    managerSubtitle() {
      if (this.__isAvoir) {
        return "Ajustez les paramètres, les notes et les lignes avant validation.";
      }
      if (this.__item.type === "BON DE COMMANDE") {
        return "Vérifiez les informations, ajustez les lignes puis enregistrez la commande.";
      }
      return this.__isFacture
        ? "Retrouvez ici tous les champs utiles pour finaliser une facture propre et cohérente."
        : "Retrouvez ici tous les champs utiles pour finaliser un devis propre et cohérent.";
    },
    managerModeBadge() {
      if (this.__isAvoir) {
        return "Avoir";
      }
      if (this.__item.type === "BON DE COMMANDE") {
        return "Commande";
      }
      return this.__isFacture ? "Facture" : "Devis";
    },
    previewTitle() {
      if (this.inPreview === "PRODS") {
        return "Catalogue produits";
      }
      if (this.inPreview === "SERVICES") {
        return "Catalogue services";
      }
      return "Aperçu du document";
    },
    previewSubtitle() {
      if (this.inPreview === "PRODS") {
        return "Ajoutez rapidement des produits sans quitter la fenêtre.";
      }
      if (this.inPreview === "SERVICES") {
        return "Ajoutez rapidement des services et travaux au document.";
      }
      return "Contrôlez la mise en page et le rendu global avant enregistrement.";
    },
    previewBadge() {
      if (this.inPreview === "TPL") {
        return "Preview";
      }
      return this.inPreview === "PRODS" ? "Produits" : "Services";
    },
    lineCountLabel() {
      const count = (this.__item.devis || []).length;
      return `${count} ligne${count > 1 ? "s" : ""}`;
    },
    getDevisID() {
      return (this.__item.devis || []).map((e) => {
        return e.id;
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.managerComposer {
  width: 100%;
}

.managerComposer :deep(.b-overlay-wrap) {
  width: 100%;
}

.managerPanels {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.managerPanels-avoir {
  flex-direction: column;
}

.managerEditionPanel {
  flex: 1 1 56%;
  padding: 0;
  margin-bottom: 10px;
  min-width: 0;
}

.managerPreviewPanel {
  flex: 1 1 44%;
  padding: 0;
  margin-bottom: 10px;
  min-width: 0;
}

.managerPanels-avoir .managerPreviewPanel,
.managerPanels-avoir .managerEditionPanel {
  width: 100%;
  flex: 1 1 100%;
}

.managerPanels-avoir .managerPreviewPanel {
  order: 1;
}

.managerPanels-avoir .managerEditionPanel {
  order: 2;
}

.managerPopupHead {
  align-items: center;
}

.managerModeBadge {
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #1e2a44 0%, #31415f 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 10px 24px rgba(30, 42, 68, 0.18);
}

.managerModeBadge-light {
  background: linear-gradient(135deg, #64748b 0%, #94a3b8 100%);
}

.managerToolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.managerToolbar-btn {
  min-width: 118px;
  border-radius: 12px;
  font-weight: 600;
}

.managerSectionHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.managerSectionEyebrow {
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.managerSectionTitle {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.managerSectionMeta {
  color: #5f6f8b;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.managerFieldsRow {
  margin-left: -8px;
  margin-right: -8px;
}

.managerField {
  margin-bottom: 14px;
  padding-left: 8px;
  padding-right: 8px;
}

.managerFieldLabel {
  margin-bottom: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.datePick .managerFieldLabel {
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.managerField :deep(.form-control),
.managerField :deep(.custom-select),
.managerField :deep(textarea),
.datePick :deep(.form-control) {
  min-height: 46px;
  border-radius: 14px;
  border-color: #dbe4f0;
  box-shadow: none;
}

.datePick :deep(.b-form-btn-label-control) {
  display: flex !important;
  align-items: stretch;
  flex-wrap: nowrap;
  position: relative;
  width: 100%;
  min-height: 46px;
  border: 1px solid #dbe4f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: none;
  overflow: visible;
}

.datePick :deep(.b-form-btn-label-control > .btn) {
  flex: 0 0 46px;
  width: 46px;
  min-width: 46px;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  border-right: 1px solid #dbe4f0 !important;
  border-radius: 0 !important;
  background: linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%) !important;
  color: #475569 !important;
  box-shadow: none !important;
}

.datePick :deep(.b-form-btn-label-control > label.form-control) {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  width: 1%;
  min-height: 44px;
  margin: 0 !important;
  padding: 0 14px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  color: #1e2a44 !important;
  text-align: left !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px !important;
  font-weight: 600;
  box-shadow: none !important;
}

.datePick :deep(.b-form-btn-label-control > .btn),
.datePick :deep(.b-form-btn-label-control > label.form-control) {
  position: relative;
  z-index: 2;
}

.datePick :deep(.b-form-btn-label-control > label.form-control.text-muted) {
  color: #94a3b8 !important;
  font-weight: 500;
}

.datePick :deep([id$="__dialog_"]) {
  position: absolute !important;
  top: calc(100% + 8px) !important;
  left: 0 !important;
  margin: 0 !important;
  z-index: 30 !important;
}

.datePick :deep(.dropdown-menu) {
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 22px 44px rgba(15, 23, 42, 0.18);
  padding: 10px;
}

.datePick :deep(.b-calendar-nav) {
  gap: 6px;
  margin-bottom: 8px;
}

.datePick :deep(.b-calendar-nav .btn) {
  min-height: 32px;
  padding: 6px 8px !important;
  border: 1px solid #dbe4f0 !important;
  border-radius: 10px !important;
  background: #fff !important;
  color: #475569 !important;
  box-shadow: none !important;
}

.datePick :deep(.b-calendar-grid-caption) {
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.datePick :deep(.b-calendar-grid-weekdays small) {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.datePick :deep(.b-calendar-grid-body .btn) {
  color: #475569 !important;
  background: #fff !important;
  border: 1px solid transparent !important;
  box-shadow: none !important;
}

.datePick :deep(.b-calendar-grid-body .btn.active),
.datePick :deep(.b-calendar-grid-body [aria-selected="true"] .btn) {
  color: #fff !important;
  background: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
}

.datePick :deep(.b-calendar-grid-body .btn.btn-outline-primary) {
  color: #1d4ed8 !important;
  border-color: #bfdbfe !important;
  background: #eff6ff !important;
}

.datePick :deep(.b-calendar-grid-help) {
  color: #94a3b8;
}

.managerPreviewCard {
  min-height: 100%;
  overflow-x: auto;
}

.managerLinesCard {
  overflow: hidden;
}

.managerPanels-avoir .managerPreviewCard {
  padding: 14px;
}

.managerPanels-avoir .managerPopup {
  gap: 16px;
}

.managerPanels-avoir .managerPopup-head,
.managerPanels-avoir .managerPopupHead {
  align-items: flex-start;
}

.managerPanels-avoir :deep(.print-sheet) {
  min-width: 0;
}

.managerPanels-avoir :deep(.print-document) {
  min-width: 900px;
}

.managerComposer :deep(.form-control option) {
  color: black;
}

@media (max-width: 991px) {
  .managerPanels {
    flex-direction: column;
    gap: 18px;
  }

  .managerEditionPanel,
  .managerPreviewPanel {
    width: 100%;
    margin-left: 0;
  }

  .managerPreviewPanel {
    margin-top: 18px;
  }
}

@media (max-width: 767px) {
  .managerPopupHead {
    align-items: flex-start;
  }

  .managerToolbar-btn {
    min-width: 0;
    flex: 1 1 calc(50% - 10px);
  }

  .managerSectionHead {
    flex-direction: column;
  }
}
</style>
